module.exports = __webpack_public_path__ + "img/service-certification.61976a49.png";